<div :class="getDynamicClass()">
    <!-- TODO: Understand why the resize event stops firing after the root element has been resized to minimal width -->
    <!-- Because of this problem, we must add the v-onresize directive to the right child column instead of to the root element-->

   

    <div :style="getPanel2Style()" class="TwoPanelLayout__Panel2"  v-onresize="onResize">
        <slot name="panel2" />
    </div>

    <div :style="getPanel1Style()" class="TwoPanelLayout__Panel1" >
        <div data-scroll-sensor-container="true" style="height:100%;overflow:auto;flex:0.4">
            <slot name="panel1" />
        </div>
    </div> 
</div>